import { render, staticRenderFns } from "./listRecommended.vue?vue&type=template&id=6160fddb&scoped=true&"
import script from "./listRecommended.vue?vue&type=script&lang=js&"
export * from "./listRecommended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6160fddb",
  null
  
)

export default component.exports